import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const VerifySeasonalBadge =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("license_seasonal_badges")
      .doc(id)
      .get()
      .then(async (query) => {
        if (query.data()) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .where("athleteID", "==", query.data().athlete_id)
            .get();
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().fan_id)
            .get();
          dispatch({
            type: "VERIFY_SEASONAL_BADGES",
            payload: {
              data: query.data(),
              athlete: athlete.docs[0].data(),
              fan: fan.data(),
            },
          });
          onComplete();
        } else {
          onComplete();
        }
      });
  };
export const verifyTalkingBadge =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("license_talking_purchases")
      .doc(id)
      .get()
      .then(async (query) => {
        if (query.data()) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().athleteId)
            .get();
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().fanId)
            .get();
          dispatch({
            type: "VERIFY_TALKING_BADGES",
            payload: {
              data: query.data(),
              athlete: athlete.data(),
              fan: fan.data(),
            },
          });
          onComplete();
        } else {
          onComplete();
        }
      });
  };

export const verifyMyBadges =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .doc(id)
      .get()
      .then(async (query) => {
        if (query.data()) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().athlete_id)
            .get();
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().fan_id)
            .get();
          dispatch({
            type: "VERIFY_MY_BADGES",
            payload: {
              data: query.data(),
              athlete: athlete.data(),
              fan: fan.data(),
            },
          });
          onComplete();
        } else {
          onComplete();
        }
      });
  };

export const verifyMomentos =
  (id, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("momento_purchases")
      .doc(id)
      .get()
      .then(async (query) => {
        if (query.data()) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().athlete_id)
            .get();
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(query.data().fan_id)
            .get();
          dispatch({
            type: "VERIFY_MOMENTO",
            payload: {
              data: query.data(),
              athlete: athlete.data(),
              fan: fan.data(),
            },
          });
          onComplete();
        } else {
          onComplete();
        }
      });
  };

export const searchBadge =
  (endorsementNumber, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      firebase
        .firestore()
        .collection("license_endorsement_purchases")
        .where("endorsementNumber", "==", endorsementNumber)
        .get()
        .then(async (query) => {
          if (query.docs.length > 0) {
            const fan = await firebase
              .firestore()
              .collection("users")
              .doc(query.docs[0].data().fanId)
              .get();
            const athlete = await firebase
              .firestore()
              .collection("users")
              .doc(query.docs[0].data().athleteId)
              .get();
            dispatch({
              type: "VERIFY_ENDORSEMENT_BADGE",
              payload: {
                data: query.docs[0].data(),
                fan: fan.data(),
                athlete: athlete.data(),
              },
            });
            onComplete("yes");
          } else {
            onComplete("no");
          }
        });
    } catch (error) {
      dispatch({
        type: "SEARCH_BADGE_FAILURE",
        payload: error.message,
      });
    }
  };
export const verifyEndorsmentBadge =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const query = await firebase
        .firestore()
        .collection("license_endorsement_purchases")
        .doc(id)
        .get();

      if (query.exists) {
        const fan = await firebase
          .firestore()
          .collection("users")
          .doc(query.data().fanId)
          .get();
        const athlete = await firebase
          .firestore()
          .collection("users")
          .doc(query.data().athleteId)
          .get();

        dispatch({
          type: "VERIFY_ENDORSEMENT_BADGE_BY_ID",
          payload: {
            data: query.data(),
            fan: fan.data(),
            athlete: athlete.data(),
          },
        });

        onComplete("yes");
      } else {
        onComplete("no");
      }
    } catch (error) {
      console.error("Error fetching document:", error);

      dispatch({
        type: "SEARCH_BADGE_FAILURE",
        payload: error.message,
      });
    }
  };

export const addVerificationPayment =
  (data, onComplete = () => {}) =>
  () => {
    firebase
      .firestore()
      .collection("verification_payment")
      .add(data)
      .then(() => {
        toast.success("Add amount");
        onComplete();
      });
  };
